<template>
    <DashboardCard
            :width="width"
            :dataDisplay="dataDisplay"
            :main_icon="main_icon"
            :icons="icon_data"
            :load_url="load_url"
            :title="title">
    </DashboardCard>
</template>

<script>
    import DashboardCard from '../../widgets/DashboardCard';

    export default {
        name: 'TodaysQAAndOfferGenerationFromKitReceived',
        components: {DashboardCard},
        props: {
            dataDisplay: {type:String, default: null},
            width: {type:Number, default: 25},
        },
        data() {
            return {
                main_icon: 'fa-light fa-file-check',
                title: 'Today\'s QA/Offer From Kit Received',
                load_url: '/dashboards/TodaysQA/',
                icon_data: [
                    {
//                        name: 'QA Current',
                        name: 'QA',
                        text_color: '#E9C46A',
                    },
                    {
//                        name: 'Offers Generated Current',
                        name: 'Offers Generated',
                        text_color: '#264653',
                    },
                ],
            };
        },
    };
</script>

<style scoped>

</style>